import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { buildProductComparePageComponentsMap } from "../blocks/componentMaps";
import { PageSkeleton } from "../components/PageSkeleton";

const ProductComparePageBody = (
    props: Immutable<{ page: templates.ProductComparePageTemplate["page"] }>,
): React.JSX.Element => {
    const components = buildProductComparePageComponentsMap({
        pageSlug: props.page.slug,
    });
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.modules.value}
            components={components}
        />
    );
};

export const Template = (
    props: Immutable<templates.ProductComparePageTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <ProductComparePageBody page={props.page} />
        </PageSkeleton>
    );
};
